import type { Rule } from 'antd/es/form';
import type { TFunction } from 'i18next';

/** Ошибки 409 API → поле формы клиента или точки доставки. */
export const CLIENT_FIELD_BY_CODE = { client_exists: 'inn', inn_locked: 'inn' };
export const POINT_FIELD_BY_CODE = { delivery_point_exists: 'name' };

// Быстрая проверка формата до запроса; контрольную сумму ИНН проверяет API (422 у поля).
export function innRules(t: TFunction): Rule[] {
  return [
    { required: true, message: t('clients.innRequired') },
    { pattern: /^(\d{10}|\d{12})$/, message: t('clients.innFormat') },
  ];
}

export function kppRules(t: TFunction): Rule[] {
  return [{ pattern: /^\d{4}[0-9A-Z]{2}\d{3}$/, message: t('clients.kppFormat') }];
}
